import './topbar.css';
import { Link } from 'react-router-dom';

export function topbar(title, link) {
    return (
        <div className="top-content">
            <div className="content">
                <nav className="top-bar">
                    <h3><i className='fa fa-users'></i> {title}</h3>
                    <nav><Link to="/"><i className='fa fa-home clfacebook'></i></Link>/<i><Link className='clfacebook' to='/'>{link}</Link></i></nav>
                </nav>
            </div>
        </div>
    )
}

